import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLang } from "@/context/LanguageContext";
import { RecipeChips } from "./DemoRecipeCard";
import { formatQty } from "@/lib/demo";

export function DemoRecipeDialog({ recipe, onClose }) {
  const { t, tv, lang } = useLang();
  if (!recipe) return null;
  const locked = recipe.tier !== "free";
  const steps = recipe.instructions?.[lang] || recipe.instructions?.fr || [];
  const unit = (u) => (u === "pc" ? t("dm_unit_pc") : u === "slice" ? t("dm_unit_slice") : u);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg rounded-3xl chenia-dialog-scroll" data-testid="demo-recipe-dialog">
        <DialogHeader><DialogTitle className="font-serif text-xl pr-6">{tv(recipe.name)}</DialogTitle></DialogHeader>
        <div className="relative aspect-[4/3] overflow-hidden rounded-2xl bg-secondary min-h-0">
          <img src={recipe.image} alt={tv(recipe.name)} className="h-full w-full object-cover" />
          {(recipe.image_illustration || recipe.image_generic) && <span className="absolute bottom-2 left-2 rounded-full bg-black/45 px-2 py-0.5 text-[10px] text-white">{t(recipe.image_illustration ? "dm_illustration" : "dm_photo_generic")}</span>}
        </div>
        <RecipeChips recipe={recipe} />
        <p className="text-xs text-muted-foreground">{t("dm_cost_note", { converted: recipe.cost?.converted ? t("dm_cost_converted") : "" })}</p>
        <p className="text-xs text-muted-foreground">{t("dm_allergens")} : {recipe.allergens?.length ? recipe.allergens.map((a) => t(`al_${a}`)).join(", ") : t("dm_none")}{recipe.nutrition?.calories != null && <> · {t("dm_kcal", { kcal: recipe.nutrition.calories })}</>}</p>
        <section>
          <h4 className="text-sm font-semibold">{t("dm_ingredients")}</h4>
          <ul className="mt-2 space-y-1 text-sm">
            {recipe.ingredients.map((i) => (
              <li key={i.key} className="flex justify-between gap-3 border-b border-border/50 py-1 last:border-0">
                <span>{tv(i.name)}</span>{i.qty != null && <span className="shrink-0 text-muted-foreground">{formatQty(i.qty)} {unit(i.unit)}</span>}
              </li>
            ))}
          </ul>
        </section>
        {locked ? <p className="rounded-xl bg-secondary/70 p-3 text-xs text-muted-foreground">{t("dm_locked_details", { plan: t(`plan_${recipe.tier}`) })}</p> : (
          <section>
            <h4 className="text-sm font-semibold">{t("dm_steps")}</h4>
            <ol className="mt-2 list-decimal space-y-1.5 pl-5 text-sm leading-relaxed">{steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
          </section>
        )}
      </DialogContent>
    </Dialog>
  );
}
